import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const errMsg = (e) => e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Something went wrong";

const SiteCtx = createContext(null);

const EMPTY = { content: {}, packages: [], cases: [], reviews: [], available: true };

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const reload = useCallback(() => api.get("/site").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const value = useMemo(() => ({ ...(data || EMPTY), loaded: !!data, reload }), [data, reload]);
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    const r = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` } });
    return r.data;
  }, [getToken]);
}
